import { FormErrors } from 'redux-form';

import type { MatchingPayload, RulePayload } from '../../nodeTypes/locations';
import { LOCATIONS_FIELD, LocationsModalFormValues } from '../locations';
import { getPhoneNumberErrorMessage } from '../validators/phoneNumber';

import { MATCH_FIELD } from './phoneNumber';
import { MATCHINGS_FIELD, NAME_FIELD } from './rules';

type Errors = {
  [Key in typeof LOCATIONS_FIELD]?: RulesError[];
};

type RulesError = {
  [MATCHINGS_FIELD]?: MatchingsError[];
  [NAME_FIELD]?: string;
};

type MatchingsError = {
  [Key in typeof MATCH_FIELD]?: string;
};

export const validate = (values: LocationsModalFormValues): FormErrors => {
  const errors: Errors = {};
  const locationsErrors: Errors[typeof LOCATIONS_FIELD] = [];

  if (values.rules) {
    values.rules.forEach((rule: RulePayload, ruleIndex: number) => {
      const matchingsErrors: RulesError[typeof MATCHINGS_FIELD] = [];
      const nameError: RulesError[typeof NAME_FIELD] = !rule.name
        ? 'Name is required'
        : '';

      rule.matchings.forEach(
        (matchings: MatchingPayload, matchingsIndex: number) => {
          const matchingsError: MatchingsError = {};
          const phoneNumberErrorMessage = getPhoneNumberErrorMessage(
            matchings?.match,
          );

          if (phoneNumberErrorMessage) {
            matchingsError.match = phoneNumberErrorMessage;
            matchingsErrors[matchingsIndex] = matchingsError;
          }
        },
      );

      const rulesError: RulesError = {
        ...(matchingsErrors.length && { matchings: matchingsErrors }),
        ...(nameError && { name: nameError }),
      };

      locationsErrors[ruleIndex] = rulesError;
    });

    if (locationsErrors.length) {
      errors.rules = locationsErrors;
    }
  }

  return errors;
};
